if (typeof ImageComparisonComponent == "undefined") {
        class ImageComparisonComponent extends HTMLElement {
            constructor() {
                super();

                this.initLoad();
                this.initComparisons();
            }

            initLoad() {
                const handler = (entries, observer) => {
                    if (entries[0].isIntersecting) {
                        const imagesContainer = this.querySelector('[data-images-container]');
                        imagesContainer.style.setProperty('--left-pos', '50%');
                        imagesContainer.querySelector('.slider-thumb-arrows').style.transform = 'rotate(0deg)';

                        setTimeout(() => imagesContainer.classList.add('loaded'), 1000)

                        observer.unobserve(this);
                    }   
                }

                const options = {
                    threshold: .7
                }

                this.observer = new IntersectionObserver(handler, options);
                this.observer.observe(this);
            }   

            initComparisons() {
                this.clicked = false;
                this.container = this.querySelector('[data-images-container]')
                this.slider = this.querySelector('[data-image-slider]');
                this.imageOverlay = this.querySelector('[data-image-overlay]');
    
                this.compareImages();
            }
            
            compareImages() {
                this.width = this.imageOverlay.offsetWidth;
                this.height = this.imageOverlay.offsetHeight;
                
                this.slider.addEventListener('mousedown', this.slideReady.bind(this));
                this.slider.addEventListener('touchstart', this.slideReady.bind(this));
                window.addEventListener('mouseup', this.slideFinish.bind(this));
                window.addEventListener('touchend', this.slideFinish.bind(this));
            }

            slideReady(e) {
                e.preventDefault();
    
                this.clicked = true;
    
                window.addEventListener('mousemove', this.slideMove.bind(this));
                window.addEventListener('touchmove', this.slideMove.bind(this));
            }
    
            slideMove(e) {
                if (!this.clicked) return false;
    
                const currentLeftPercent = this.getCursorLeft(e);
                this.container.style.setProperty('--left-pos', `${currentLeftPercent}%`);
            }
    
            slideFinish(e) {
                this.clicked = false;
            }

            getCursorLeft(e) {
                const event = e.changedTouches ? e.changedTouches[0] : e;
                
                const { left, width } = this.container.getBoundingClientRect();
                const sliderButtonWidthPercent = (this.slider.getBoundingClientRect().width + 4) * 100 / width;
                const min = sliderButtonWidthPercent / 2;
                const max = 100 - min;

                const delta = event.pageX - left;
                let percent = (delta / width) * 100;    

                if (percent < min) percent = min;
                if (percent > max) percent = max;

                return percent;    
            }
        }
        
        window.addEventListener('load', () => customElements.define('image-comparison-component', ImageComparisonComponent));
    }